'use strict';

angular.module('ClinicApp').controller('ModalCoverageDetails', function($scope, $modalInstance, appointment, OCAppointmentUtil, OCUtil) {
  $scope.OCAppointmentUtil = OCAppointmentUtil;
  $scope.appointment = appointment;

  $scope.inNetworkOptions = [{
    label: 'In Network',
    value: 'inNetwork',
  }, {
    label: 'Out of Network',
    value: 'outOfNetwork',
  }];

  function showPreferredNetwork() {
    var testValues = [
      _.get($scope.appointment, 'insuranceData.maximums.preferredNetwork.individual'),
      _.get($scope.appointment, 'insuranceData.maximums.preferredNetwork.family'),
      _.get($scope.appointment, 'insuranceData.deductibles.preferredNetwork.individual'),
      _.get($scope.appointment, 'insuranceData.deductibles.preferredNetwork.family'),
    ];
    return _.any(testValues, function(val) {
      return !_.isEmpty(val);
    });
  }

  if (showPreferredNetwork()) {
    $scope.inNetworkOptions.push({
      label: 'Preferred Network',
      value: 'preferredNetwork',
    });
  }

  $scope.tabs = {
    GENERAL: 'General',
    SPECIFIC: 'Specific',
  };

  $scope.userSelected = {
    inNetwork: $scope.inNetworkOptions[0].value,
    tab: $scope.tabs.GENERAL,
  };

  $scope.startDate = _.get($scope.appointment, 'insuranceData.planStartDate') || _.get($scope.appointment, 'insuranceData.eligibilityStartDate');
  $scope.endDate = _.get($scope.appointment, 'insuranceData.planEndDate') || _.get($scope.appointment, 'insuranceData.eligibilityEndDate');
  $scope.showPlanActive = $scope.startDate && $scope.endDate;
  if ($scope.showPlanActive) {
    // The last parameter [) means the start date is inclusive, but the end date is not
    // See: https://momentjs.com/docs/#/query/is-between/
    $scope.planActive = moment().isBetween($scope.startDate, $scope.endDate, null, '[)');
  }

  $scope.procedures = _.map(_.get($scope.appointment, 'insuranceData.serviceInformation'), function(data, name) {
    data.name = name;
    var limitationDescriptions = _.uniq(_.get(data, 'limitations.descriptions', []));
    var limitationMessages = _.uniq(_.get(data, 'limitations.messages', []));
    data.notes = limitationDescriptions.concat(limitationMessages);
    return data;
  });

  $scope.showCoverage = function() {
    return !_.isEmpty(_.get($scope.appointment, 'insuranceData.coverage'));
  };

  $scope.getCoverageDiff = function(total, remaining) {
    if (OCUtil.isNil(total) || OCUtil.isNil(remaining)) {
      return null;
    } else {
      return total - remaining;
    }
  };

  $scope.selectTab = function(tab) {
    $scope.userSelected.tab = tab;
  };

  $scope.close = function() {
    $modalInstance.close();
  };
});
